import api from "./api";

const KWS_CACHE_KEY = "KWS_FACTORY_CACHE";

function getKwsCache() {
  try {
    return JSON.parse(sessionStorage.getItem(KWS_CACHE_KEY)) || {};
  } catch {
    return {};
  }
}

function setKwsCache(factoryCode, isKws) {
  const cache = getKwsCache();
  cache[factoryCode] = isKws;
  sessionStorage.setItem(KWS_CACHE_KEY, JSON.stringify(cache));
}

export async function getFactoryFacilities(factoryCode) {
  return api.get(
    `/fulfilment/tva/api/v1/factory-facilities?factory_code=${encodeURIComponent(factoryCode)}`
  );
}

export async function getVendorFacilities(facilityIds) {
  const filter = `id:${facilityIds.join(",")}`;
  return api.get(
    `/vms/api/v1/vendorfacilities?filter=${encodeURIComponent(filter)}&count=${facilityIds.length}`
  );
}

/**
 * Checks whether a factory has KWS (production) facilities.
 * Only positive (true) results are cached in sessionStorage — negative results
 * are re-checked on each call so vendors aren't locked out if backend status changes.
 *
 * @param {string} factoryCode - e.g. "FCT_123"
 * @returns {Promise<boolean>} true if the factory has at least one KWS facility
 */
export async function checkFactoryIsKws(factoryCode) {
  const cache = getKwsCache();
  if (factoryCode in cache) return cache[factoryCode];

  try {
    const facilityIds = await getFactoryFacilities(factoryCode);
    const validIds = (facilityIds || []).filter((id) => id > 0);

    if (validIds.length === 0) {
      return false;
    }

    const response = await getVendorFacilities(validIds);
    const facilities = response?.records || [];
    const isKws = facilities.some((f) => f.profile_type === "KWS");
    if (isKws) setKwsCache(factoryCode, true); // only cache positive results
    return isKws;
  } catch (err) {
    console.error("KWS check failed for factory:", factoryCode, err);
    return false;
  }
}
